<template lang="html">

  <div class="newOrder">

    <breadcrumb :nameSection = 'nameSection' :listRoutes = 'listRoutes'></breadcrumb>

    <div class="purchaseOrders">
      <div class="">
         <div class="form-title-block form-title-principal"style="margin-top:20px;margin-left:20px">
            <span>Usuarios</span>
                <div class="form-title-block"  style="margin-left:79%">
                    <b-button v-b-modal.modalReevaluation class="btn btn-primary btn-lg"  >
                     <i class="fas fa-plus"></i>Añadir Usuario
                     </b-button>
                </div>
          </div>

      <b-modal hide-footer hide-header centered id="modalReevaluation" ref="modalReevaluation">
      <form @submit.prevent="checkServer(typeUser)">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Registro de Usuarios</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="hideModalReevaluetion"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>



          <div class="modal-body modal-scroll modal-tabs" id="modal-body">
            <div class="form-login">
              <div class="tab-content" id="myTabContent">
                  <div class="form-group">
                      <label for class="float-left">Tipo de usuario :</label>
                      <select class="form-control form-control-lg sen-form-input-with-tooltip" v-model="typeUser">
                        <option value="">Seleccionar</option>
                        <option value="cliente"  >Cliente</option>
                        <option value="operador">Operador</option>
                        <option value="administrador" >Administrador</option>
                      </select>

                  </div>

                  <div class="form-group" v-if=" (typeUser ==='cliente') || (typeUser ==='administrador') || (typeUser ==='operador') ">
                    <label for class="float-left">Nombre :</label>
                    <input type="text"  v-model="name" class="form-control" :maxlength="50"id="firstname" aria-describedby="firstname"  placeholder="Ingrese el  nombre"  required>
                    <small v-if="responseName" class="text-danger d-flex align-items-start">{{responseName}}</small>
                  </div>
                  <div class="form-group " v-if="typeUser ==='cliente'  || typeUser ==='administrador' || (typeUser ==='operador') ">
                    <label for class="float-left">Apellido :</label>
                    <input type="text"   v-model="lastname" class="form-control" :maxlength="100"id="lastname" aria-describedby="lastname"  placeholder="Ingrese el apellido"  required>
                    <small v-if="responseLast" class="text-danger d-flex align-items-start">{{responseLast}}</small>
                  </div>
                  <div class="form-group " v-if="typeUser ==='cliente'">
                    <label for class="float-left">Email :</label>
                    <input type="email"   v-model="email" :class="'form-control login__input sen-form-input-with-tooltip ' + validateUser" id="email" aria-describedby="email"  placeholder="Ingresa el email" required >
                     <small v-if="responseUser" class="text-danger d-flex align-items-start">{{responseUser}}</small>
                  </div>
                   <div class="form-group " v-if="typeUser ==='administrador' || (typeUser ==='operador') ">
                    <label for class="float-left">Username :</label>
                    <input type="text"  v-model="username" :class="'form-control login__input sen-form-input-with-tooltip ' + validateUserName" id="username" aria-describedby="username"  placeholder="Ingresa el username" required >
                    <small v-if="responseUserName" class="text-danger d-flex align-items-start">{{responseUserName}}</small>
                  </div>
                  <div class="form-group " v-if="(typeUser ==='cliente') || (typeUser ==='administrador') || (typeUser ==='operador')">
                    <label for class="float-left">DNI :</label>
                    <input type="text"  v-model="dni"  @keypress="onlyNumber " class="form-control " id="dni" aria-describedby="dni"  placeholder="Ingresa el DNI" required >
                  </div>
                  <div class="form-group " v-if="typeUser ==='cliente' || typeUser ==='administrador' || (typeUser ==='operador') ">
                      <label for class="float-left">Teléfono :</label>
                    <input type="tel" v-model="telephone" @keypress="onlyNumber " class="form-control"  id="phone3" aria-describedby="phone"  v-digitsonly placeholder="Numero de teléfono" required >
                    <small v-if="responsePhone!=''" class="text-danger d-flex align-items-start">{{responsePhone}}</small>
                  </div>
                  <div class="form-group " v-if="typeUser ==='cliente' || typeUser ==='administrador' || (typeUser ==='operador') ">
                    <label for class="float-left">Código de País :</label>
                    <select id="select-search" class="form-control" v-model="country_code" required >
                        <option
                          :value="option.dial_code"
                          v-for="(option) in listCountry"
                          :key="option.id"
                        >{{option.dial_code}} - {{option.name}}</option>
                      </select>
                    <!-- <input type="tel" v-model="country_code"  class="form-control" :maxlength="9"  v-digitsonly placeholder="Código de país" required > -->
                  </div>
                  <div class="form-group" v-if="(typeUser ==='operador') ">
                      <label for class="float-left">Tipo de operador :</label>
                      <select id="operator_type" name="operator_type"   v-model="operator_type" class="form-control form-control-lg sen-form-input-with-tooltip"required>
                        <option value="" disabled="disabled">Seleccionar</option>
                        <option value="1">Envio</option>
                        <option value="2">Recepción</option>
                      </select>
                  </div>

                 <div class="form-group" v-if="(typeUser ==='operador') ">
                      <label for class="float-left">Seleccionar ciudad :</label>
                      <select id="city_id" name="city_id"   v-model="city_id" class="form-control form-control-lg sen-form-input-with-tooltip" required>
                        <option value="" disabled="disabled">Seleccionar</option>
                        <option value="2">Miami</option>
                        <option value="12">Buenos Aires</option>
                        <option value="22">Lima</option>
                      </select>
                  </div>
                  <div class="form-group" v-if="typeUser ==='cliente' || typeUser ==='administrador' || (typeUser ==='operador') ">
                      <label for class="float-left">Género :</label>
                      <select id="genre" name="sexo"   v-model="sexo" class="form-control form-control-lg sen-form-input-with-tooltip" required>
                        <option value="0" selected="true" disabled="disabled">Seleccionar</option>
                        <option value="1">Masculino</option>
                        <option value="2">Femenino</option>
                      </select>
                     <small v-if="responseGenre" class="text-danger d-flex align-items-start">{{responseGenre}}</small>
                  </div>

                   <div class="form-group "v-if="typeUser ==='cliente' || typeUser ==='administrador'|| (typeUser ==='operador') ">
                    <label for class="float-left">Fecha de nacimiento :</label>
                    <input type="date"   v-model="date"  class="form-control" id="date"  required >
                   <small v-if="responseDate" class="text-danger d-flex align-items-start">{{responseDate}}</small>
                  </div>

                  <div class="form-group " v-if="typeUser ==='cliente' || typeUser ==='administrador' || (typeUser ==='operador') ">
                    <label for class="float-left">Contraseña :</label>
                    <input type="password"   v-model="password" class="form-control" id="password"  placeholder="Ingrese la contraseña" required >
                     <small v-if="responsePass" class="text-danger d-flex align-items-start">{{responsePass}}</small>
                    <small v-if="response2Pass" class="text-danger d-flex align-items-start">{{response2Pass}}</small>
                  </div>
                   <div class="form-group "v-if="typeUser ==='cliente' || typeUser ==='administrador'|| (typeUser ==='operador') ">
                    <label for class="float-left">Repita contraseña :</label>
                    <input type="password"   v-model="checkPassword" class="form-control"  id="password2" placeholder="Repita la contraseña" required >
                   <small v-if="responseCheck" class="text-danger d-flex align-items-start">{{responseCheck}}</small>
                  </div>
              </div>
            </div>
          </div>

          <div class="modal-footer text-right" v-if="typeUser.length > 0">
            <button
              type="submit"
              id="submit"
              class="btn btn-primary btn-lg"
            >Registrar Usuario</button>
          </div>

          <div class="modal-footer text-right" v-else>
            <button
              class="btn btn-primary btn-lg" disabled
            >Registrar Usuario</button>
          </div>
        </div>
      </form>
      </b-modal>


         <div class="filter-block-content" style="margin-top:10px;margin-left:20px">

              <div class="wrap">
                <form action="" class="formulario2">
                  <div class="radio">


                    <input type="radio"   id="cli" :value="'clientes'"v-model="selectionUser" >
                    <label for="cli">Clientes</label>

                    <input type="radio" id="oper" :value="'operadores'" v-model="selectionUser" >
                    <label for="oper">Operadores</label>

                    <input type="radio" id="admin"  :value="'administradores'" v-model="selectionUser" >
                    <label for="admin">Administradores</label>


                  </div>
                </form>
            </div>
        </div>


        <!-- <select class="form-control" name="selectUser" v-model="selectionUser">
          <option selected :value="'clientes'">clientes</option>
          <option :value="'operadores'">operadores</option>
          <option :value="'administradores'">administradores</option>
        </select> -->


      </div>
      <div class="">
        <chart1 v-if="selectionUser == 'clientes'"></chart1>
        <chart2 v-if="selectionUser == 'operadores'"></chart2>
        <chart3 v-if="selectionUser == 'administradores'"></chart3>
      </div>

    </div>



  </div>
</template>

<script>
import breadcrumb from '@/components/prefab/structures/breadcrumb.vue'
import chart1 from '@/components/prefab/elements/user-chart1-list.vue'
import chart2 from '@/components/prefab/elements/user-chart2-list.vue'
import chart3 from '@/components/prefab/elements/user-chart3-list.vue'
import axios from 'axios'

export default {
  components: { chart1, chart2, chart3, breadcrumb },
  data() {
    return {
      responseCheck: '',
      validatePass: '',
      responsePass: '',
      response2Pass: '',
      validateDate: '',
      responseDate: '',
      validateGenre: '',
      responseGenre: '',
      responsePhone: '',
      validatePhone: '',
      validateUser: '',
      validateUserName: '',
      responseUserName: '',
      responseUser: '',
      responseName: '',
      responseLast: '',
      name: '',
      lastname: '',
      username: '',
      telephone: '',
      dni: '',
      sexo: 0,
      date: '',
      password: '',
      checkPassword: '',
      typeUser: '',
      email: '',
      username: '',
      operator_type: '',
      city_id: '',
      country_code: '+51',
      selectionUser: 'clientes',
      loading: '',
      listCountry: '',
      nameSection: 'Usuarios',
      listRoutes: [{ nameRoute: 'user-list', titleRoute: 'Usuarios' }],
    }
  },
  created() {
    let url = ''
    url = process.env.API_URL + '/api/countryCodes'
    axios
      .get(url)
      .then((response) => {
        this.listCountry = response.data
      })
      .catch((error) => {
        if (error) {
          this.listCountry = 'No hay datos'
        }
      })
  },
  methods: {
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault()
      }
    },
    resetInput(typeUser) {
      if (typeUser === 'cliente') {
        this.name = ''
        this.lastname = ''
        this.email = ''
        this.dni = ''
        this.telephone = ''
        this.sexo = ''
        this.date = ''
        this.password = ''
        this.checkPassword = ''
      }
      if (typeUser === 'administrador') {
        this.name = ''
        this.lastname = ''
        this.username = ''
        this.dni = ''
        this.telephone = ''
        this.sexo = ''
        this.date = ''
        this.password = ''
        this.checkPassword = ''
      }
      if (typeUser === 'operador') {
        this.name = ''
        this.lastname = ''
        this.username = ''
        this.dni = ''
        this.telephone = ''
        this.sexo = ''
        this.date = ''
        this.password = ''
        this.checkPassword = ''
        this.operator_type = ''
        this.city_id = ''
      }
    },
    hideModalReevaluetion() {
      this.$refs.modalReevaluation.hide()
    },
    checkServer(typeUser) {
      if (typeUser === 'cliente') {
        let self = this
        let url = ''
        this.toggleLoading()
        this.$store.commit('TOGGLE_LOADING')
        this.resetResponse()
        if (this.validateForm() && this.validateFormClient()) {
          this.resetResponse()
          url = process.env.API_URL + '/api/client/create-client'
          axios
            .post(url, {
              name: this.name,
              surnames: this.lastname,
              country_code: this.country_code,
              cellphone: this.telephone,
              gender: this.sexo === '1' ? 'M' : 'F',
              birthdate: this.date,
              email: this.email,
              password: this.password,
              document_number: this.dni,
            })
            .then((response) => {
              self.toggleLoading()
              console.log('success')
              console.log(response.data)
              this.resetInput(typeUser)
              this.typeUser = ''
              this.$refs.modalReevaluation.hide()
              location.reload()
            })
            .catch((error) => {
              let responseMessage
              let errorFlag
              if (error.response) {
                if (error.response.status === 400) {
                  self.response = 'Error 400'
                } else if (error.response.status === 404) {
                  self.response = 'Error 404'
                } else if (
                  error.response.status === 422 ||
                  error.response.status === 401
                ) {
                  console.log('entro')
                  /* self.response = 'Errores de validación, por favor, vuelve a intentarlo' */
                  if (error.response.data.errors.hasOwnProperty('email')) {
                    responseMessage = error.response.data.errors.email[0]
                    console.log(responseMessage)
                    errorFlag = parseInt(
                      responseMessage.substr(0, responseMessage.indexOf('.'))
                    )
                    if (errorFlag === 1) {
                      self.validateEmail('emailInc')
                    }
                  } else if (
                    error.response.data.errors.password[0]
                      .slice(0, 1)
                      .toString() === '2'
                  ) {
                    let passInc = 'passInc'
                    self.validateUser(passInc)
                  }
                } else if (error.response.status === 500) {
                  self.response = 'Error de servidor. Inténtelo más tarde.'
                } else {
                  self.response = 'Error inesperado'
                }
              } else if (error.request) {
                console.log(error.request)
              } else {
                console.log('Error', error.message)
              }
              console.log(error.config)
            })
        }
      }
      if (typeUser === 'administrador') {
        let self = this
        let url = ''
        this.toggleLoading()
        this.$store.commit('TOGGLE_LOADING')
        this.resetResponse()
        if (this.validateForm() && this.validateFormAdmin()) {
          this.resetResponse()
          url = process.env.API_URL + '/api/admin/create-admin'
          axios
            .post(url, {
              name: this.name,
              surnames: this.lastname,
              country_code: this.country_code,
              cellphone: this.telephone,
              gender: this.sexo === '1' ? 'M' : 'F',
              birthdate: this.date,
              username: this.username,
              password: this.password,
              document_number: this.dni,
            })
            .then((response) => {
              self.toggleLoading()
              console.log('success')
              console.log(response.data)
              this.resetInput(typeUser)
              this.typeUser = ''
              this.$refs.modalReevaluation.hide()
              location.reload()
            })
            .catch((error) => {
              let responseMessage
              let errorFlag
              if (error.response) {
                if (error.response.status === 400) {
                  self.response = 'Error 400'
                } else if (error.response.status === 404) {
                  self.response = 'Error 404'
                } else if (
                  error.response.status === 422 ||
                  error.response.status === 401
                ) {
                  console.log('entro')
                  /* self.response = 'Errores de validación, por favor, vuelve a intentarlo' */
                  if (error.response.data.errors.hasOwnProperty('username')) {
                    responseMessage = error.response.data.errors.username[0]
                    console.log(responseMessage)
                    self.validateUsername('userNameInc')
                  } else if (
                    error.response.data.errors.password[0]
                      .slice(0, 1)
                      .toString() === '2'
                  ) {
                    let passInc = 'passInc'
                    self.validateUser(passInc)
                  }
                } else if (error.response.status === 500) {
                  self.response = 'Error de servidor. Inténtelo más tarde.'
                } else {
                  self.response = 'Error inesperado'
                }
              } else if (error.request) {
                console.log(error.request)
              } else {
                console.log('Error', error.message)
              }
              console.log(error.config)
            })
        }
      }
      if (typeUser === 'operador') {
        let self = this
        let url = ''
        this.toggleLoading()
        this.$store.commit('TOGGLE_LOADING')
        if (this.validateForm() && this.validateFormAdmin()) {
          url = process.env.API_URL + '/api/operator/create-operator'
          axios
            .post(url, {
              name: this.name,
              surnames: this.lastname,
              country_code: this.country_code,
              cellphone: this.telephone,
              gender: this.sexo === '1' ? 'M' : 'F',
              birthdate: this.date,
              username: this.username,
              password: this.password,
              document_number: this.dni,
              operator_type: this.operator_type,
              city_id: this.city_id,
            })
            .then((response) => {
              self.toggleLoading()
              console.log('success')
              console.log(response.data)
              this.resetInput(typeUser)
              this.typeUser = ''
              this.$refs.modalReevaluation.hide()
              location.reload()
            })
            .catch((error) => {
              let responseMessage
              let errorFlag
              if (error.response) {
                if (error.response.status === 400) {
                  self.response = 'Error 400'
                } else if (error.response.status === 404) {
                  self.response = 'Error 404'
                } else if (
                  error.response.status === 422 ||
                  error.response.status === 401
                ) {
                  console.log('entro')
                  /* self.response = 'Errores de validación, por favor, vuelve a intentarlo' */
                  if (error.response.data.errors.hasOwnProperty('username')) {
                    responseMessage = error.response.data.errors.username[0]
                    console.log(responseMessage)
                    self.validateUsername('userNameInc')
                  } else if (
                    error.response.data.errors.password[0]
                      .slice(0, 1)
                      .toString() === '2'
                  ) {
                    let passInc = 'passInc'
                    self.validateUser(passInc)
                  }
                } else if (error.response.status === 500) {
                  self.response = 'Error de servidor. Inténtelo más tarde.'
                } else {
                  self.response = 'Error inesperado'
                }
              } else if (error.request) {
                console.log(error.request)
              } else {
                console.log('Error', error.message)
              }
              console.log(error.config)
            })
        }
      }
    },
    toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : ''
    },
    resetResponse() {
      this.response = ''
      this.validateName = ''
      this.validateUserName = ''
      this.responseName = ''
      this.validateLast = ''
      this.responseLast = ''
      this.validateUser = ''
      this.responseUser = ''
      this.validateUserName = ''
      this.responseUserName = ''
      this.validatePass = ''
      this.responsePass = ''
      this.response2Pass = ''
      this.validateCheck = ''
      this.responseCheck = ''
      this.validatePhone = ''
      this.responsePhone = ''
      this.validateGenre = ''
      this.responseGenre = ''
      this.validateDate = ''
      this.responseDate = ''
    },
    validateForm() {
      console.log(
        this.name,
        this.lastname,
        this.email,
        this.password,
        this.checkPassword,
        this.telephone,
        this.sexo,
        this.date,
        this.country_code
      )
      let name = 'name'
      let last = 'last'
      let pass = 'pass'
      let check = 'check'
      let names = this.validateNames(name)
      let surnames = this.validateNames(last)
      let phone = this.validateNumber()
      let genre = this.validateSex()
      let birthdate = this.validateBday()
      let pass1 = this.validatePassword(pass)
      let pass2 = this.validatePassword(check)
      let checkPass = this.validate2Password()
      return (
        names &&
        surnames &&
        phone &&
        genre &&
        birthdate &&
        pass1 &&
        pass2 &&
        checkPass
      )
    },
    validateFormClient() {
      console.log('Solo clientes', this.email)
      let user = this.validateEmail()
      return user
    },
    validateFormAdmin() {
      console.log(this.username)
      let userName2 = this.validateUsername()
      console.log('userName2', userName2)
      return userName2
    },
    validateFormOperator() {
      console.log(this.username)
      let userName2 = this.validateUsername()
      console.log('userName2', userName2)
      return userName2
    },
    validateUsername(atr = null) {
      if (atr === null) {
        this.responseUserName =
          this.username.length < 1 || this.username.length > 20
            ? 'Nombres debe contener entre 1 y 20 carácteres.'
            : ''
        return !(this.username < 1 || this.username.length > 20)
      } else if (atr === 'userNameInc') {
        console.log('Ingreso al duplicado del userName')
        this.validateUserName = 'incorrect'
        this.responseUserName = 'UserName ya registrado'
      }
    },
    validateNames(atr) {
      if (atr === 'name') {
        this.validateName =
          this.name.length < 1 || this.name.length > 50
            ? 'incorrect'
            : 'correct'
        this.responseName =
          this.name.length < 1 || this.name.length > 50
            ? 'Nombres debe contener entre 1 y 50 carácteres.'
            : ''
        return !(this.name.length < 1 || this.name.length > 50)
      } else if (atr === 'last') {
        this.validateLast =
          this.lastname.length < 1 || this.lastname.length > 100
            ? 'incorrect'
            : 'correct'
        this.responseLast =
          this.lastname.length < 1 || this.lastname.length > 100
            ? 'Apellidos deben contener entre 1 y 100 carácteres.'
            : ''
        return !(this.lastname.length < 1 || this.lastname.length > 100)
      }
    },
    validateEmail(atr = null) {
      if (atr === null) {
        let aux = new RegExp('[\\w+\\-\\.]+\\@[a-z]+\\.[a-z]{2,}')
        this.validateUser = aux.test(this.email) ? 'correct' : 'incorrect'
        this.responseUser = aux.test(this.email)
          ? ''
          : 'Ingresa un correo válido. Ex: ejemplo@grupocasza.com'
        return aux.test(this.email)
      } else if (atr === 'emailInc') {
        this.validateUser = 'incorrect'
        this.responseUser = 'Correo ya registrado'
      }
    },
    validateNumber() {
      let validated = this.telephone.length === 9
      this.validatePhone = validated ? 'correct' : 'incorrect'
      this.responsePhone = validated ? '' : 'El telefono debe tener 9 digitos'
      return validated
    },
    validateSex() {
      console.log(this.sexo, this.sexo == 0)
      this.validateGenre = !(this.sexo == 0) ? 'correct' : 'incorrect'
      this.responseGenre = !(this.sexo == 0)
        ? ''
        : 'Debes seleccionar un género.'
      return !(this.sexo == 0)
    },
    validateBday() {
      console.log(this.date)
      console.log(parseInt(this.date))
      let aux = new Date()
      let date =
        parseInt(this.date) >= 1900 &&
        aux.getFullYear() - parseInt(this.date) >= 18
      this.validateDate = date ? 'correct' : 'incorrect'
      this.responseDate = date ? '' : 'Ingrese una fecha correcta.'
      console.log('salio del validateBday')
      return date
    },
    validatePassword(atr) {
      if (atr === 'pass') {
        this.validatePass =
          this.password.length < 8 || this.password.length > 20
            ? 'incorrect'
            : 'correct'
        this.responsePass =
          this.password.length < 8 || this.password.length > 20
            ? 'La contraseña debe tener entre 8 y 20 carácteres.'
            : ''
        return !(this.password.length < 8 || this.password.length > 20)
      } else if (atr === 'check') {
        this.validateCheck =
          this.checkPassword.length < 8 || this.checkPassword.length > 20
            ? 'incorrect'
            : 'correct'
        this.responseCheck =
          this.checkPassword.length < 8 || this.checkPassword.length > 20
            ? 'La contraseña debe tener entre 8 y 20 carácteres.'
            : ''
        return !(
          this.checkPassword.length < 8 || this.checkPassword.length > 20
        )
      }
    },
    validate2Password() {
      let aux = this.password === this.checkPassword
      console.log('aux', aux)
      this.validatePass = aux ? 'correct' : 'incorrect'
      this.validateCheck = aux ? 'correct' : 'incorrect'
      this.response2Pass = aux
        ? ''
        : 'Las contraseñas deben ser iguales. Por favor, intenta de nuevo.'
      return aux
    },
  },
}
</script>

<style >
.formulario2 {
}
.formulario2 h2 {
  font-size: 16px;
  color: #001f3f;
  margin-bottom: 20px;
  margin-left: 20px;
}
.formulario2 .radio label,
.formulario2 .checkbox label {
  display: inline-block;
  cursor: pointer;
  position: relative;
  padding: 5px 15px 5px 51px;
  font-size: 1em;
  border-radius: 5px;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.formulario2 .radio label:hover,
.formulario2 .checkbox label:hover {
  background: rgba(240, 235, 235, 0.1);
}
.formulario2 .radio label:before,
.formulario2 .checkbox label:before {
  content: '';
  display: inline-block;
  width: 17px;
  height: 17px;
  position: absolute;
  left: 15px;
  border-radius: 50%;
  background: none;
  border: 3px solid;
}
.formulario2 input[type='radio'] {
  display: none;
}
.formulario2 input[type='radio']:checked + label:before {
  display: none;
}
.formulario2 input[id='cli']:checked + label {
  padding: 5px 15px;
  background: #007bff;
  border-radius: 2px;
  color: #fff;
}
.formulario2 input[id='oper']:checked + label {
  padding: 5px 15px;
  background: #007bff;
  border-radius: 2px;
  color: #fff;
}
.formulario2 input[id='admin']:checked + label {
  padding: 5px 15px;
  background: #007bff;
  border-radius: 2px;
  color: #fff;
}

/*# sourceMappingURL=estilos.css.map */
</style>



// WEBPACK FOOTER //
// userListView.vue?46f58b77